export default {
  'FEED' (state) {
    return state.feed
  },
  'FEEDS' (state) {
    return state.feeds
  }
}
